import React, { Component } from 'react';
import '../css/Devis.css';
import { connect } from "react-redux";
import back from '../img/back.svg';
import next from '../img/next.svg';
import Commande from './Commande';
import close from '../img/close.png';
import logo_oeil from '../img/eye_black.png';
import { changeSuiviP, changeTitle, changeStyleProfil, changeColorC, changeColorD, changeBoolP, changeStyleD, changeStyleC, changeCT, changeDT} from "../actions/index";


function mapDispatchToProps(dispatch) {
    return {
      changeTitle: title_header => dispatch(changeTitle(title_header)),
      changeSuiviP: suivi_page => dispatch(changeSuiviP(suivi_page)),
      changeStyleProfil: style_profil => dispatch(changeStyleProfil(style_profil)),
      changeStyleD: style_d => dispatch(changeStyleD(style_d)),
      changeStyleC: style_c => dispatch(changeStyleC(style_c)),
      changeDT: dt => dispatch(changeDT(dt)),
      changeCT: ct => dispatch(changeCT(ct)),
      changeBoolP: boolp => dispatch(changeBoolP(boolp)),
      changeColorD: colord => dispatch(changeColorD(colord)),
      changeColorC: colorc => dispatch(changeColorC(colorc))
    };
}

const mapStateToProps = state => {
  return { facture_user:state.facture_user,commande_user:state.commande_user, profile_user: state.profile_user   };
};



class Facture extends Component {

 constructor(props){
    super(props);
    this.state = {
      deb: 0,
      nb_devis:15,
      search:false,
      find:'',
      style_tr:{backgroundColor:"#fafafa"},
      test:false
    }
    this.handlePageS = this.handlePageS.bind(this);
    this.handlePageP = this.handlePageP.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSuppr = this.handleSuppr.bind(this);
  }


  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
    this.setState({search:true});
  }




  formatDate(date){
    if(typeof(date)==='number'){
      date=date.toString();
    }
    if(date.length > 5){
        let year = date.substring(0,4);
        let month = date.substring(4,6);
        let day = date.substring(6,8);

    return day+"/"+month+"/"+year;
    }

    return '';
    
   
  
  }

  renderTable(nb,nb2){
    let test = false;
    let style_tr = {backgroundColor:"lightgreen"};
    if(this.state.search){
      return this.renderTable2(nb,nb2);          
    }
    else{
      return this.props.facture_user.map((facture,index) => {
        const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Num_Facture, Montant_Facture, Date_Comptable, Date_Echeance} = facture;
        var date_eche = new Date(Date_Echeance.substring(0,4),Date_Echeance.substring(4,6)-1,Date_Echeance.substring(6,8));
        var diff = new Date() - date_eche;
        diff = diff/(1000 * 60 * 60 * 24);

        if(diff < 30 && diff > 0 ){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td  title="date d'écheance dépassé de moins de 30 jours" style={{color:"orange"}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        if(diff >= 30 && diff < 60){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td title="date d'écheance dépassé de plus de 30 jours" style={{color:'rgb(242,12,173)'}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        if(diff >= 60 ){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td title="date d'écheance dépassé de plus de 60 jours" style={{color:"red"}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        else{
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        
        return null;
    });
    }
    
  }

  handleC(data){
    this.props.changeCT(true);
    this.props.changeDT(false);
    this.props.changeTitle( 'Commandes' );
    this.props.changeSuiviP( <Commande  key={"commande"} dataD={data} joinD="true"/> );
    this.props.changeStyleProfil({display:"none"});
    this.props.changeStyleC({backgroundColor:"#f5f6f8"});
    this.props.changeStyleD({backgroundColor:"#f5f6f8"});
    this.props.changeBoolP(false);
    this.props.changeColorC(false);
    this.props.changeColorD(true);
  }

  renderTable2(nb,nb2){
    let test = false;
    let mapping = [];
    let i = 0;
    let style_tr = {backgroundColor:"lightgreen"};
    this.props.facture_user.forEach((facture,index) => {
      const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Num_Facture, Montant_Facture, Date_Comptable, Date_Echeance} = facture;
      if((Client_Groupe.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Libelle_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Code_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Facture.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Montant_Facture.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || this.formatDate(Date_Comptable).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1  || this.formatDate(Date_Echeance).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1) && id)
      {
        mapping[i] = facture;
        i++;
      }
    });
    while((nb-mapping.length)>15){
      nb-=15;
      nb2-=15;
    }
    return mapping.map((facture,index) => {
      const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Num_Facture, Montant_Facture, Date_Comptable, Date_Echeance} = facture;
      if(Client_Groupe.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Libelle_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Code_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Facture.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Montant_Facture.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || this.formatDate(Date_Comptable).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1  || this.formatDate(Date_Echeance).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1)
      {
        var date_eche = new Date(Date_Echeance.substring(0,4),Date_Echeance.substring(4,6)-1,Date_Echeance.substring(6,8));
        var diff = new Date() - date_eche;
        diff = diff/(1000 * 60 * 60 * 24);

        if(diff < 30 && diff > 0 ){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td  title="date d'écheance dépassé de moins de 30 jours" style={{color:"orange"}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        if(diff >= 30 && diff < 60){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td title="date d'écheance dépassé de plus de 30 jours" style={{color:'rgb(242,12,173)'}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        if(diff >= 60 ){
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td title="date d'écheance dépassé de plus de 60 jours" style={{color:"red"}}>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
        else{
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }

        }
          if(index<nb && index>=nb2){ 
            return (
              <tr key={id} >
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td style={{textAlign:"left"}}>{Num_Commande}</td>
                <td style={{textAlign:"left"}}>{Num_Facture}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Montant_Facture)}</td>
                <td>{this.formatDate(Date_Comptable)}</td>
                <td>{this.formatDate(Date_Echeance)}</td>
              </tr>
            )
          }
      }
      return null;
    });
    
  }

  handleSuppr(event){

    this.setState({find:''});
   
  }
 
 handlePageS(){
    if(this.state.nb_devis < this.props.facture_user.length){
      let nb_deb = this.state.deb;
      let nb_fin = this.state.nb_devis;
      this.setState({deb:nb_deb+15});
      this.setState({nb_devis:nb_fin+15});
    }
    
  }

  handlePageP(){

    if(this.state.deb >= 15){
      let nb_deb = this.state.deb;
      let nb_fin = this.state.nb_devis;
      this.setState({deb:nb_deb-15});
      this.setState({nb_devis:nb_fin-15});
    }
   
  }

  render() {
    
    return (
    <div className="devis">
    <input
        id="search"
        type="text"
        placeholder="Recherche"
        name="find"
        value={this.state.find}
        onChange={this.onChange}
      /> {this.state.find.localeCompare("")==0?null:<img id="croix_cmd3" onClick={(event) => this.handleSuppr(event)} src={close} alt="croix"/>}
      <table id = "t1" >
        <thead>
          <tr>
            <th>GROUPE</th>
            <th>LIBELL&Eacute; CLIENT</th> 
            <th>CODE CLIENT</th>
            <th>N° COMMANDE</th>
            <th>N° FACTURE</th>
            <th>MONTANT TTC</th>
	          <th>DATE FACTURE</th>
            <th>DATE &Eacute;CHEANCE</th>
          </tr>
        </thead>
        <tbody>
            {this.renderTable(this.state.nb_devis,this.state.deb)}
        </tbody>
      </table>
      <div id="page_d">
        <img id="pagePD" onClick={(event) => this.handlePageP(event)} src={back} alt="Logo back"/>
        <img id="pageSD" onClick={(event) => this.handlePageS(event)} src={next} alt="Logo next"/>
      </div>
    </div>
      );
    }
  }
export default connect(mapStateToProps, mapDispatchToProps)(Facture);
